import { Component, inject } from '@angular/core';
import { TableContext } from '../../../services/table/table-context.service';
import { NgClass, NgStyle } from '@angular/common';
import { GroupColsComponent } from '../group-cols/group-cols.component';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-adhock-table',
  imports: [NgClass, NgStyle, GroupColsComponent, NgIcon],
  templateUrl: './adhock-table.component.html',
  styleUrl: './adhock-table.component.scss',
})
export class AdhockTableComponent {
  tableContext = inject(TableContext);

  tableData = this.tableContext.tableData();

  rows = this.tableData.rows;
  cols = this.tableData.heads;
  tableFormatter = this.tableContext.tableFormatService;
}
